// @react
import React, { ReactElement } from 'react'
// @typings
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @libraries
// @commons
// @context
// @components
import Box from '@bit/atd.web.box'
import SkeletonLoader from '@bit/atd.web.loaders.skeleton'
// @module components
import QueryError from 'modules/common/components/Errors/QueryError'
import ProfileVisibility from 'modules/common/components/ProfileVisibility'
import MemberVisibility from 'modules/common/components/MemberVisibility'

/**
 * 5.0.1.1 Profile - Personal Information - Visibility
 * UX: https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3123%3A16072
 *
 * endpoint: user/profile
 * response: UserProfileDTO
 *
 * fields:
 * publicProfile
 * amemberDirectoryListing
 *
 */

type PropsType = {
  data?: GetUserQuery
  isLoading: boolean
}

const Togglers = ({ data, isLoading }: PropsType): ReactElement => {
  const togglers = (
    <>
      <ProfileVisibility data={data} isLoading={isLoading} />
      <br />
      {data?.user?.membership.isMember && (
        <MemberVisibility data={data} isLoading={isLoading} />
      )}
    </>
  )
  const box = (content: ReactElement): ReactElement => {
    return <Box>{content}</Box>
  }

  return !isLoading ? box(togglers) : box(<SkeletonLoader />)
}

const Visibility = (): ReactElement => {
  const { loading: isLoading, error: isError, data } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { fetchPolicy: 'cache-first' })

  if (isError || (!data && !isLoading)) {
    return <QueryError />
  }

  return <Togglers data={data} isLoading={isLoading} />
}

export default Visibility
